import "../css/TopBar.css";
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

function TopBarLogin() {

  var location = useLocation();
  var { login } = location.state || {};
  const navigation = useNavigate()
  function clicktologinscreen() {
    navigation('/', { state: { login } })
  }

    const disableRightClick = (e) => {
    e.preventDefault();
  };
  return (
    <div className="top-bar"  onContextMenu={disableRightClick}>
      <div>
        {/* <img src=""    width={10} height={5}
         
         
        />  */}
        {/* <span>for happy marriages</span> */}
      </div>
      <label className="name"><b>Don't have an account</b> </label>
      <button onClick={clicktologinscreen} className="login_button">Register</button>
      <div >

        <b>Need help? Call</b>
        <span> 72007 45891</span>
      </div>

    </div>
  );
};

export default TopBarLogin;
